import React, { useState } from 'react';
import Tree from './Tree';
import { RightOutlined, LeftOutlined } from '@ant-design/icons';
import { Button } from 'antd';

const VendorTraceChart = ({ selectedMetric, selectedVendorName, maxTraceLevel, filteredData, toggleChildren, consentTypeDescription, consentTypeName }) => {
    const [isDisabled, setIsDisabled] = useState(false);
    const [zoomSide, setZoomSide] = useState('next');

    return (
        <div>
            <div className={'vendorTraceTreeDescriptionWrapper'}>
                <div className={'vendorTraceTreeDescription'}>{consentTypeDescription}</div>
                <div className={'show-more-layers-buttons'} >
                    <Button className={'show-more-layers-button'} id={'prev-layers-button'} shape="circle" disabled={isDisabled || zoomSide === 'next'} icon={<LeftOutlined />} />
                    <Button className={'show-more-layers-button'} id={'next-layers-button'} shape="circle" disabled={isDisabled || zoomSide === 'prev'} icon={<RightOutlined />} />
                </div>
            </div>
            <div id="vendorTraceTreeWrapper">
                <Tree
                    filteredData={filteredData}
                    selectedMetric={selectedMetric}
                    selectedVendorName={selectedVendorName}
                    onClickShowMoreLayersButton={(e) => {
                        setZoomSide(e);
                    }}
                    onClickZoomButton={(e) => {
                        setIsDisabled(e);
                    }}
                    maxTraceLevel={maxTraceLevel}
                    toggleChildren={(e) => toggleChildren(e)}
                    consentTypeName={consentTypeName}
                />
            </div>
        </div>
    );
};

export default VendorTraceChart;
